/*global SVP */
'use strict';

import * as domUtils from '../util/dom';
import ErrorType from '../constants/error-type';

var Sizzle = require('sizzle');
var config = require('../config');
var time = require('../util/time');

var NAMESPACE = 'ui-timeline-controls';

var ERROR_ATTRIBUTE = 'svp_is--error';
var VISIBLE_ATTRIBUTE = 'svp_is--visible';

var CLASSNAMES = {
	errorContainer: 'svp_js-error',
	errorIcon: 'svp_js-error--icon',
	errorMessage: 'svp_js-error--message',
	errorLinkContainer: 'svp_js-error--link-container',
	errorLink: 'svp_js-error--link',
	errorLiveClock: 'svp_js-error--live-clock',
	errorRetry: 'svp_js-error--retry'
};

var ICONS = {
	general: 'svp_ui-error__icon--blocked',
	geoblock: 'svp_ui-error__icon--geoblock'
};

var LIVE_PING_INTERVAL_MS = 10000;
var liveInterval;

var createFn = function (api) {

	function _createElement() {
		var errorNode = domUtils.fromString(
			'<div class="svp_ui-error ' + CLASSNAMES.errorContainer + '">\
				<div class="svp_ui-error__inner">\
					<span class="svp_ui-error__icon ' + CLASSNAMES.errorIcon + '"></span>\
					<div class="svp_ui-error__message-container">\
						<span class="svp_ui-error__message ' + CLASSNAMES.errorMessage + '" aria-live="assertive" role="alert"></span>\
						<button class="svp_ui-error__retry ' + CLASSNAMES.errorRetry + '">Försök igen</button>\
						<div class="svp_ui-error__message-link--container ' + CLASSNAMES.errorLinkContainer + '">\
							<span class="svp_ui-error__message-icon--arrow"></span>\
							<a target="_blank" class="' + CLASSNAMES.errorLink + '" href=""></a>\
						</div>\
					</div>\
				</div>\
			</div>');

		if (SVP._cssNotLoadedClass) {
			domUtils.addClass(errorNode, SVP._cssNotLoadedClass);
			errorNode.style.visibility = 'hidden';
		}

		return errorNode;
	}

	function _getElement(className) {
		return api && Sizzle('.' + className, api.element())[0];
	}

	function _createClockFace(startTime) {
		var time = new Date(startTime * 1000),
			hours = time.getHours(),
			minutes = time.getMinutes(),
			hoursElement = domUtils.fromString('<div class="svp_ui-error__live-clock-hours"></div>'),
			minutesElement = domUtils.fromString('<div class="svp_ui-error__live-clock-minutes"></div>'),
			containerDiv = domUtils.fromString('<div class="svp_ui-error__live-clock ' + CLASSNAMES.errorLiveClock + '"></div>');

		hoursElement.style.transform = 'rotate(' + ((hours + (minutes / 60)) / 12 * 360) + 'deg)';
		minutesElement.style.transform = 'rotate(' + (minutes / 60 * 360) + 'deg)';
		containerDiv.appendChild(hoursElement);
		containerDiv.appendChild(minutesElement);
		containerDiv.appendChild(domUtils.fromString('<div class="svp_ui-error__live-clock-knot"></div>'));

		return containerDiv;
	}

	function _displayError(errorObject, iconClass, liveStartTime) {
		if (errorObject && api.state()) {
		    api.hide(); //hide all ui components except error

			api.pause(); // TODO: should we do something smarter here?
			var errorMessage = _getElement(CLASSNAMES.errorMessage),
				errorIcon = _getElement(CLASSNAMES.errorIcon),
				errorLink = _getElement(CLASSNAMES.errorLink),
				errorLinkContainer = _getElement(CLASSNAMES.errorLinkContainer),
				errorLiveClock = _getElement(CLASSNAMES.errorLiveClock),
				errorRetry = _getElement(CLASSNAMES.errorRetry);

			errorMessage.innerHTML = errorObject.text;
			if (errorLiveClock) {
				errorLiveClock.parentElement.removeChild(errorLiveClock);
			}

			domUtils.removeClass(errorIcon, Object.keys(ICONS));

			if (liveStartTime) {
				errorIcon.parentElement.insertBefore(_createClockFace(liveStartTime), errorIcon);
				liveInterval = setInterval(function () {
					config.metadataFetchFunction(api.data().videoId, function (metadata) {
						if (metadata.live) {
							clearInterval(liveInterval);
							api.load();
						}
					}, () => {
					    // empty
                    });
				}, LIVE_PING_INTERVAL_MS);
			} else if (iconClass) {
				domUtils.addClass(errorIcon, iconClass);
			}

			if (errorObject.link) {
				errorLink.setAttribute('href', errorObject.link.url);
				errorLink.innerHTML = errorObject.link.text;
				domUtils.show(errorLinkContainer);
			} else {
				domUtils.hide(errorLinkContainer);
			}

			if (errorObject.retry) {
				domUtils.addClass(errorRetry, VISIBLE_ATTRIBUTE);
			} else {
				domUtils.removeClass(errorRetry, VISIBLE_ATTRIBUTE);
			}

			domUtils.addClass(api.element(), ERROR_ATTRIBUTE);
		}
	}

	function _reset() {
		var errorMessage = _getElement(CLASSNAMES.errorMessage);
		errorMessage.innerHTML = '';
		domUtils.removeClass(api.element(), ERROR_ATTRIBUTE);
		api.show(); //show all ui components
    clearInterval(liveInterval);
	}

	function _errorHandler(errorEvent) {
		var detail = errorEvent && errorEvent.detail ? errorEvent.detail : {},
			key,
			errorObject,
			liveStartTime = 0,
			iconClass = ICONS.general;


		if (detail.target && detail.target.error) { //standard video error
			switch (detail.target.error.code) {
				case detail.target.error.MEDIA_ERR_ABORTED:
					key = ErrorType.MEDIA_ERROR_ABORTED;
					break;
				case detail.target.error.MEDIA_ERR_NETWORK:
					key = ErrorType.MEDIA_ERROR_NETWORK;
					break;
				case detail.target.error.MEDIA_ERR_DECODE:
					key = ErrorType.MEDIA_ERROR_DECODE;
					break;
				case detail.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
					key = ErrorType.MEDIA_ERROR_SRC_NOT_SUPPORTED;
					break;
				default:
					key = ErrorType.DEFAULT_ERROR;
					break;
			}
			errorObject = config.messages.error[key];
		} else if (detail.name) { //our own error
			key = detail.name;
			errorObject = config.messages.error[key];
			switch(key) {
				case ErrorType.LIVE_NOT_STARTED_ERROR:
					errorObject.text = 'Sändningen startar ' + time.formatPrettyVideoDate(new Date(detail.timestamp * 1000));
					liveStartTime = detail.timestamp;
					break;
                case ErrorType.GEO_BLOCK_ERROR:
					iconClass = ICONS.geoblock;
					break;
			}
		} else {
			errorObject = config.messages.error.defaultError;
		}

		if (api.state()) {
			_displayError(errorObject, iconClass, liveStartTime);
		}

	}

	api.element().appendChild(_createElement());
	api.on(NAMESPACE + '.error', _errorHandler.bind(this));
	api.on(NAMESPACE + '.play', _reset.bind(this));

	_getElement(CLASSNAMES.errorRetry).addEventListener('click', function () {
		api.play();
	});

	api.filters.push({
		load: function () {
			_reset();
		},
		reset: function () {
			_reset();
		}
	});

};

module.exports = {
	create: createFn,
	destroy: function (api) {
		if (api) {
			var element = api.element(),
				errorContainer = Sizzle('.' + CLASSNAMES.errorContainer, element)[0];

			api.off(NAMESPACE + '.error');
			api.off(NAMESPACE + '.play');

			domUtils.removeClass(api.element(), ERROR_ATTRIBUTE);

			if (errorContainer) {
				errorContainer.parentElement.removeChild(errorContainer);
			}

			clearInterval(liveInterval);
		}
	}
};




// WEBPACK FOOTER //
// ./src/js/plugins/error-handler.js